import { Component, type ErrorInfo, type ReactNode } from 'react';
import { PageBackButton } from './PageBackButton';

interface PageErrorBoundaryProps {
  children: ReactNode;
  resetKey: string;
  title: string;
  description: string;
}

interface PageErrorBoundaryState {
  hasError: boolean;
}

export class PageErrorBoundary extends Component<PageErrorBoundaryProps, PageErrorBoundaryState> {
  state: PageErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): PageErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[PageErrorBoundary]', error, info.componentStack);
  }

  componentDidUpdate(prevProps: PageErrorBoundaryProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 bg-bgContainer min-h-full">
          <div className="flex items-center gap-3 mb-6">
            <PageBackButton />
            <h1 className="text-2xl font-bold text-textDefault">{this.props.title}</h1>
          </div>
          <p className="text-textSecondary">{this.props.description}</p>
        </div>
      );
    }
    return this.props.children;
  }
}
